// Module
var code = "<avto-form model=\"vm.avto\" tachographs=\"vm.tachographs\"\n           on-save=\"$close(model)\"\n           on-close=\"$close()\">\n</avto-form>";
// Exports
module.exports = code;